/**
 * @module Links
 * @description
 */
import { handleClick, handleBuyClick } from "./helpers";

export const headerMenuLinks = [
  {
    icon: "icon-magnifying-glass",
    href: "https://frontier.com/search",
    title: "Search",
    handler: handleClick,
  },
  { icon: "icon-shopping-cart", title: "Buy", handler: handleBuyClick },
];

export const userMenuLinks = [
  { href: "/account#/summary", title: "Account Summary" },
  { href: "/account#/payments/onetime", title: "My Payments" },
  { href: "/account#/statements/current", title: "My Bills" },
  { href: "/account#/profile", title: "My Profile" },
  {
    href: "/resources/myfrontier-mobile-app",
    title: "MyFrontier Mobile App",
    target: "_blank",
  },
];

export const complementaryMenuLinks = [
  { href: "https://frontier.com/", title: "Residential" },
  { href: "/business", title: "Business" },
  { href: "https://enterprise.frontier.com/", title: "Enterprise" },
  { href: "https://wholesale.frontier.com/home/", title: "Wholesale" },
  { href: "https://frontier.com/resources/multifamily/", title: "Multifamily" },
];

export const footerLinks = [
  {
    title: "Small Business",
    links: [
      { href: "/fiber-internet", title: "Frontier Fiber" },
      { href: "/unified-communications", title: "Frontier + RingCentral" },
      { href: "/fiber-voice", title: "Business Voice" },
      { href: "/secure", title: "Secure Pro" },
      { href: "/internet-backup", title: "Internet Backup" },
      { href: "/premium-tech-pro", title: "Premium Tech Pro" },
    ],
  },
  {
    title: "Frontier Sites",
    links: [
      { href: "https://frontier.com/", title: "Residential" },
      { href: "/", title: "Enterprise" },
      { href: "https://wholesale.frontier.com/home", title: "Wholesale" },
      { href: "https://frontier.yahoo.com/", title: "Frontier Yahoo Portal" },
    ],
  },
  {
    title: "Support",
    links: [
      { href: "/help-center", title: "Help Center" },
      {
        href: "https://frontier.com/helpcenter/categories/support-wizard",
        title: "Support Wizard",
      },
      {
        href: "https://frontier.com/helpcenter/categories/ticket-status",
        title: "Trouble Ticket Status",
      },
      {
        href: "https://frontier.com/helpcenter/categories/order-status",
        title: "Order Status",
      },
      { href: "https://frontier.com/contact-us", title: "Contact Us" },
      { href: "https://frontier.com/local", title: "Find Your City" },
      {
        href: "https://frontier.com/resources/myfrontier-mobile-app",
        title: "My Frontier App",
      },
    ],
  },
  {
    title: "Corporate",
    links: [
      {
        href: "https://frontier.com/corporate/company/overview",
        title: "Company",
      },
      {
        href: "https://investor.frontier.com/corporate-profile/default.aspx",
        title: "Investors",
      },
      { href: "https://frontier.com/corporate/news/home", title: "News" },
      {
        href: "https://frontier.com/corporate/responsibility/home",
        title: "Responsibility",
      },
      {
        href: "https://frontier.com/corporate/company/supplier",
        title: "Suppliers",
      },
      {
        href: "https://frontier.com/corporate/responsibility/inspection-files/home",
        title: "Public Inspection Files",
      },
      { href: "https://frontier-careers.com/", title: "Careers" },
    ],
  },
  {
    title: "My Account",
    links: [{ href: "https://frontier.com/login", title: "Login" }],
  },
];

export const socialLinks = [
  {
    icon: "icon-linkedin",
    href: "https://www.linkedin.com/company/frontier-communications",
    title: "LinkedIn",
  },
  {
    icon: "icon-x",
    href: "https://twitter.com/FrontierCorp",
    title: "Twitter-X",
  },
  {
    icon: "icon-facebook",
    href: "https://www.facebook.com/FrontierCorp",
    title: "Facebook",
  },
];

export const copyrightLinks = [
  {
    href: "https://frontier.com/corporate/policies",
    title: "Policies & Notifications",
  },
  { href: "https://frontier.com/corporate/terms", title: "Terms & Conditions" },
  {
    href: "https://frontier.com/corporate/privacy-policy",
    title: "Privacy Policy",
  },
  { href: "https://frontier.com/sitemap-adhoc-page", title: "Site Map" },
  {
    href: "https://frontier.com/corporate/privacy-policy-california",
    title: "California Privacy Policy",
  },
  {
    href: "https://frontier.com/corporate/privacy-policy-connecticut",
    title: "Connecticut Privacy Policy",
  },
  { href: "", title: "", oneTrust: true },
];
